import { ILieferantRechnungService } from './ILieferantRechnungService';
import BaseServie from '@/services/baseService';
import { RechnungFilterDto } from '@/types/RechnungFilterDto';
import {
    MwstSatzApiDto,
    RechnungFormularApiDto,
    SelectListItemApiDto,
    TvsKundeDetailApiDto,
    TvsKundeVonZugriffeApiDto,
    TvsLieferantRechnungApiDtoSearchResponseApi,
    TvsLieferantRechnungDetailApiDto
} from '@/api-schema';
import { AxiosResponse } from 'axios';

export class LieferantRechnungService extends BaseServie implements ILieferantRechnungService {
    private RESOURCE_URL: string;
    private DOKUMENTE_URL: string;
    private TEILNEHMERZUGRIFF_URL: string;

    constructor() {
        super();
        this.RESOURCE_URL = `${this.BASE_URL}rechnungen/lieferant`;
        this.DOKUMENTE_URL = `${this.BASE_URL}dokumente`;
        this.TEILNEHMERZUGRIFF_URL = `${this.BASE_URL}teilnehmerzugriff`;

        console.debug('ArchivService::constructor', this.RESOURCE_URL);
    }

    async getAll(filter: RechnungFilterDto): Promise<TvsLieferantRechnungApiDtoSearchResponseApi> {
        return super.GET<TvsLieferantRechnungApiDtoSearchResponseApi>(`${this.RESOURCE_URL}` + super.serializeObjectToQuerystring(filter)).then((response) => {
            return response;
        });
    }

    async getDetails(xmlDokumentGuid: string): Promise<Array<TvsLieferantRechnungDetailApiDto>> {
        return super.GET<Array<object>>(`${this.RESOURCE_URL}/` + xmlDokumentGuid).then((response) => {
            return response;
        });
    }

    async downloadBeleg(id: string): Promise<AxiosResponse<File>> {
        return super.DOWNLOAD<File>(`${this.DOKUMENTE_URL}/download/` + id).then((response) => {
            return response;
        });
    }
    async getTvsKundenVonLieferant(): Promise<Array<TvsKundeVonZugriffeApiDto>> {
        return super.GET<Array<TvsKundeVonZugriffeApiDto>>(`${this.TEILNEHMERZUGRIFF_URL}/getTvsKundenVonLieferant`).then((response) => {
            return response;
        });
    }

    async submitInvoice(request: RechnungFormularApiDto): Promise<any> {
        console.debug('LieferantRechnungService::submitInvoice', request);

        const formData = new FormData();
        formData.append('tvsCustomerNumber', String(request.tvsCustomerNumber));
        formData.append('documentIdentifier', String(request.documentIdentifier));
        formData.append('documentIssueDate', request.documentIssueDate);
        formData.append('xmlData', request.xmlData, 'invoice.xml');
        formData.append('pdfData', request.pdfData, 'invoice.pdf');

        return super.POST(`${this.RESOURCE_URL}`, formData);
    }

    async getTvsKundeDetails(kundenNummer: string): Promise<TvsKundeDetailApiDto> {
        return super.GET<TvsKundeDetailApiDto>(`${this.BASE_URL}teilnehmer/kunde/${kundenNummer}`).then((response) => {
            return response;
        });

        // Temporary mock response
        /*
        return Promise.resolve({
            tvsKundennummer: 12345,
            firmenname: 'Muster Kunde AG',
            adresse1: 'Hauptstraße 100',
            adresse2: 'Gebäude B',
            adresse3: '3. Etage',
            plz: 8000,
            ort: 'Zürich',
            land: 'CH'
        });*/
    }
    async getUnitsOfMeasurement(language: string): Promise<SelectListItemApiDto[]> {
        return super.GET<SelectListItemApiDto[]>(`${this.BASE_URL}rechnungen/masseinheit/items/${language}`).then((response) => {
            return response;
        });
    }
    async getMwstSatzList(): Promise<MwstSatzApiDto[]> {
        return super.GET<MwstSatzApiDto[]>(`${this.BASE_URL}rechnungen/mwst/items`).then((response) => {
            return response;
        });
        // Temporary mock response
        /* return Promise.resolve([
            {
                percentage: 7.7,
                default: true
            },
            {
                percentage: 2.5,
                default: false
            },
            {
                percentage: 3.7,
                default: false
            },
            {
                percentage: 0,
                default: false
            }
        ]);*/
    }
}

export const lieferantRechnungService = new LieferantRechnungService();
